import { useMutation, useQueryClient } from '@tanstack/react-query'
import api from '@/lib/api'
import { useAccessToken, useCurrentUser } from '@/features/auth/state/auth'
import { TypeContrato } from '../utils/enum'

export function useCreateAgreement(id_client: string) {
  const queryClient = useQueryClient()
  const user = useCurrentUser()
  const token = useAccessToken()
  return useMutation({
    mutationFn: async ({ contracts, typeRegime }: { contracts: TypeContrato[]; typeRegime: string }) => {
      if (!user) throw new Error('Usuário ou Tenant não autenticado')

      const body = {
        contracts,
        typeRegime,
        id_client: id_client
      }
      console.log(`regimeesssssssssssssssse`, typeRegime)
      if (!body.contracts || !body.id_client) {
        throw new Error('Campos obrigatórios ausentes')
      }

      const response = await api.post(`/agreement/vincular`, body, {
        headers: { Authorization: `Bearer ${token}` }
      })

      if (!response.data) {
        throw new Error('Erro ao criar contrato')
      }
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['agreement'] })
    }
  })
}
